module.exports = __webpack_public_path__ + "img/1489398900.74ca7580.jpg";